var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMarkerFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77129 0C2.58087 0 0 2.69604 0 6.02883C0 7.76296 0.830029 9.33452 1.64709 10.7842C2.64572 12.5862 3.83888 14.266 5.22659 15.7562C5.52488 16.0813 6.01784 16.0813 6.32897 15.7562C7.54807 14.4963 8.62452 13.0738 9.53236 11.5564C10.5051 9.91695 11.5556 8.02024 11.5556 6.02883C11.5426 2.70959 8.96172 0 5.77129 0ZM5.77129 9.52419C3.83888 9.52419 2.26961 7.88489 2.26961 5.86625C2.26961 3.84761 3.83888 2.20831 5.77129 2.20831C7.7037 2.20831 9.27298 3.83406 9.27298 5.86625C9.27298 7.89844 7.7037 9.52419 5.77129 9.52419Z",
    fill: "#FF1744"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarkerFilled);
export default __webpack_public_path__ + "static/media/icon-marker-filled.af2782d285c46a0d5c81fb55be2386ce.svg";
export { ForwardRef as ReactComponent };